import AppError from '../errors/AppError';
import { useCustomerPortalAuth } from '../hooks/custmerPortalAuth';
import { IPaginationReturn } from '../interfaces/IPaginationReturn';
import IInvoice from '../interfaces/IInvoice';
import { useRequest } from './useRequest';

const useCustomerPortalInvoiceService = () => {
  const request = useRequest<IInvoice>();
  const { customerPortalSession, customerPortalCustomerSelected } = useCustomerPortalAuth();

  const listInvoices = async (queryParams: string): Promise<IPaginationReturn<IInvoice[]>> => {
    return request
      .getManyPaginated({
        path: `customer-portal/invoices?${queryParams}`,
        headers: {
          Authorization: `bearer ${customerPortalSession.token.access_token}`,
          tenant: customerPortalSession.user.tenant,
          customer: customerPortalCustomerSelected.id,
        },
      })
      .catch(error => {
        throw new AppError(error.message, error.status);
      });
  };

  return { listInvoices };
};

export { useCustomerPortalInvoiceService };
